import React, { useState } from "react";
// Redux
import { useDispatch, useSelector } from "react-redux";

// Components
import ButtonComponent from "../../../../../app/common-components/ButtonComponent.jsx";
import CustomSelectSearch from "../../../../../app/common-components/custom-select-with-search/index.jsx";
import CustomModal from "../../../../../app/common-components/CustomModal.jsx";
import CustomSelectDropDown from "../../../../../app/common-components/CustomSelectDropDown.jsx";
import DiscardChanges from "../../../../../app/common-components/DiscardChanges.jsx";
import CustomSelectdata from "../../../../../app/common-components/Dropdown/CustomSelect.jsx";
import Input from "../../../../../app/common-components/form/input.jsx";
import { Multipledatepicker } from "../../../../../app/common-components/MultiDatePicker/Multipledatepicker.jsx";
import CustomSelect from "../../../../../app/common-components/select/index.jsx";
import Spinners from "../../../../../app/common-components/Spinner.jsx";
import TimePicker from "../../../../../app/common-components/TimePicker/Timepicker.jsx";

// Internal Components
import DataImportTable from "./DataImportTable.js";

// Styles
import "./style.scss";

// Slice
import {
  changeDataStatus,
  dataImportSave,
  ModuleListApi,
  Servicegroupdropdown,
} from "./DataImportSlice.js";

// 3rd Party Libraries
import PropTypes from "prop-types";
import { Col, Row } from "react-bootstrap";

// Utils
import { useCommonAlert } from "../../../../../app/utilities/helpers.js";
import { dayOption, frequencyOptions } from "./Constants.js";


const DataImportComponent = (props) => {
  const dispatch = useDispatch();
  const { userName } = useSelector((state) => state.common.loggedUser);
  const { getDILoader, saveDILoader, ModuleList, listTableDIData } =
    useSelector((state) => state.DataImportConfig);
  const getOptionsFromList = (data, key) => {
    return data
      .map((item) => item[key])
      .filter((value) => Array.isArray(value) && value.length > 0)
      .flat()
      .map((value) => ({ label: value, value }));
  };

  const optionsGroup = getOptionsFromList(
    listTableDIData?.data || [],
    "groupName"
  );
  const optionsService = getOptionsFromList(
    listTableDIData?.data || [],
    "serviceName"
  );

  const [awsvalue, setAWSvalue] = useState(false);
  const [optionfilter, setoptionfilter] = useState(false);
  const [selectedGroup, setSelectedGroup] = useState([]);
  const [selectedServices, setSelectedServices] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const { callCommonAlert, hideCommonAlert } = useCommonAlert();
  const [state, setState] = useState({
    addBodyOpen: false,
    formData: {
      modulename: "",
      toolName: "",
      importFrequency: "",
      scheduleTime: "",
      importOn: "",
      id: 0,
      status: 1,
    },
    addBodyData: false,
    conformationPopup: false,
    sortByColumn: "",
    sortingOrder: "",
    headerSortingState: {
      accessor: "",
      isDataSorted: false,
      isSorted: false,
    },
  });

  const handleAdd = async (id) => {
    fetchListApi();
    dispatch(ModuleListApi());
    setState((state) => ({
      ...state,
      addBodyOpen: true,
      formData: {
        modulename: "",
        toolName: "",
        importFrequency: "",
        scheduleTime: "",
        importOn: "",
        id: id,
        status: 1,
      },
    }));
  };
  const getbyId = async (rowDetails) => {
    if (rowDetails?.moduleName === "Architecture Compliance") {
      setAWSvalue(true);
      setSelectedServices(optionsService);
      setSelectedGroup(optionsGroup);
    } else {
      setAWSvalue(false);
    }

    setState((state) => ({
      ...state,
      addBodyOpen: true,
      formData: {
        modulename: rowDetails?.moduleName ?? "",
        toolName: rowDetails?.tool ?? "",
        id: rowDetails?.id ?? 0,
      },
    }));
    let importOnData = rowDetails?.importOn;
    if (rowDetails?.importFrequency == "Weekly") {
      const selectedDays = rowDetails?.importOn
        .split(",")
        .map((day) => day.trim().toLowerCase());
      importOnData = dayOption.filter((option) =>
        selectedDays.includes(option.value.toLowerCase())
      );
    }
    if (rowDetails?.importFrequency == "Monthly") {
      const selectedDays = rowDetails?.importOn
        .split(",")
        .map((day) => parseInt(day, 10));
      importOnData = selectedDays;
    }
    setState((state) => ({
      ...state,
      formData: {
        modulename: rowDetails?.moduleName,
        toolName: rowDetails?.tool,
        importFrequency: rowDetails?.importFrequency,
        scheduleTime: rowDetails?.time,
        importOn: importOnData,
        id: rowDetails?.id,
        status: rowDetails?.status,
      },
    }));
  };
  const changeStatus = async (row, checked) => {
    const DataStatus = checked ? 1 : 0;
    dispatch(
      changeDataStatus({ id: row.id, status: DataStatus, userName })
    ).then((data) => {
      if (data.payload.statusCodeValue == 202) {
        callAlert("success", data.payload.body);
      } else if (data.payload.statusCodeValue == 400) {
        callAlert("error", data.payload.body);
      } else {
        callAlert("error", "Something went wrong please try again.");
      }
    });
  };
  const addmodalHide = () => {
    setAWSvalue(false);
    setSelectedServices([]);
    setSelectedGroup([]);
    setState((state) => ({
      ...state,
      addBodyOpen: false,
      addBodyData: false,
      formData: {
        modulename: "",
        toolName: "",
        importFrequency: "",
        scheduleTime: "",
        importOn: "",
        id: 0,
        status: 1,
      },
    }));
  };

  const callAlert = (type, msg) => {
    callCommonAlert(type, msg);
    hideCommonAlert();
  };

  const ValidationFrom = () => {
    var valid = true;
    if (
      !state.formData.modulename ||
      !state.formData.toolName ||
      !state.formData.importFrequency ||
      !state.formData.scheduleTime ||
      !state.formData.importOn
    ) {
      callAlert("warning", "Please fill in all the fields.");
      valid = false;
    }
    return valid;
  };
  const onChange = (name, value) => {
    let updatedFormData = {
      ...state.formData,
      [name]: value,
    };
    if (name === "modulename") {
      if (value === "Architecture Compliance") {
        setAWSvalue(true);
      } else {
        setAWSvalue(false);
      }
      updatedFormData.toolName = "";
    }

    if (name === "importFrequency") {
      if (value === "Daily") {
        updatedFormData.importOn = value;
      } else {
        updatedFormData.importOn = "";
      }
    }

    setState((prevState) => ({
      ...prevState,
      formData: updatedFormData,
      conformationPopup: true,
    }));
  };

  const saveFunction = () => {
    const validation = ValidationFrom();
    let ImportData = state.formData.importOn;

    if (state.formData.importFrequency === "Weekly") {
      ImportData = Array.isArray(state.formData.importOn)
        ? state.formData.importOn
          .map((date) => date.value.toUpperCase())
          .join(",")
        : "";
    } else if (state.formData.importFrequency === "Monthly") {
      ImportData = Array.isArray(state?.formData?.importOn)
        ? state.formData.importOn.map((date) => date).join(",")
        : "";
    }
    const groupValues = selectedGroup.map((group) => group.value);
    const serviceValues = selectedServices.map((group) => group.value);
    const savePayload = {
      alertDays: 0,
      createBy: "",
      createdDt: "",
      id: state.formData.id,
      importFrequency: state.formData.importFrequency,
      importOn: ImportData,
      lastTriggeredDateAndTime: "",
      moduleName: state.formData.modulename,
      status: state.formData.status,
      time: state.formData.scheduleTime,
      tool: state.formData.toolName,
      groupName: groupValues || [],
      serviceName: serviceValues || [],
      updateBy: "",
      updateDt: "",
    };
    if (validation) {
      dispatch(dataImportSave({ savePayload, userName })).then((data) => {
        if (data.payload.statusCodeValue == 200) {
          callAlert("success", data.payload.body);
          setState((state) => ({
            ...state,
            addBodyOpen: false,
          }));
        } else if (data.payload.statusCodeValue == 400) {
          callAlert("error", data.payload.body);
        } else {
          callAlert("error", "Something went wrong please try again.");
        }
      });
    }
  };
  const handleSelected = async (selectedList = []) => {
    setState((state) => ({
      ...state,
      formData: {
        ...state.formData,
        importOn: selectedList,
      },
      conformationPopup: true,
    }));
  };
  const handleTimeChange = (value) => {
    setState((prevState) => ({
      ...prevState,
      formData: {
        ...state.formData,
        scheduleTime: value,
      },
      conformationPop: true,
    }));
  };
  //For Multi Date Picker
  let selectedDates = [];

  const handleDateChange = async (newDates = []) => {
    selectedDates = newDates.map((date) => date.day);
    setState((state) => ({
      ...state,
      formData: {
        ...state.formData,
        importOn: selectedDates,
      },
    }));
  };
  /* */

  const ToolSelector = ({ modulename, onChange }) => {
    const filteredToolOptions = Array.isArray(ModuleList)
      ? ModuleList.find((tool) => tool?.moduleName === modulename)
      : null;

    const toolOptions = Array.isArray(filteredToolOptions?.toolNames)
      ? filteredToolOptions.toolNames.map((tool) => ({
        label: tool,
        value: tool,
      }))
      : [];

    return (
      <>
        <label>Tool<span className="RedHighlight">*</span></label>
        <div className="frmgroup addSchedule">
          <CustomSelectSearch
            containerClassName="frmgroup default-input"
            isSearchable={false}
            placeholder="Select"
            options={toolOptions}
            value={
              state.formData.toolName
                ? {
                  value: state.formData.toolName,
                  label: state.formData.toolName,
                }
                : null
            }
            isMulti={false}
            name="Tool Name"
            hideSelectedOptions={false}
            isDisabled={state.formData.id !== 0}
            closeMenuOnSelect={true}
            onChange={(choice) => {
              onChange("toolName", choice.value);
            }}
          />
        </div>
      </>
    );
  };
  const groupOptions = Object.keys(optionfilter).map((group) => ({
    label: group,
    value: group,
  }));

  const handleGroupChange = (selectedGroups) => {
    setSelectedGroup(selectedGroups);

    const combinedServices = selectedGroups.flatMap((group) => {
      const groupName = group.value;
      return optionfilter[groupName] || [];
    });

    const uniqueServices = [...new Set(combinedServices)].map((service) => ({
      label: service,
      value: service,
    }));

    setServiceOptions(uniqueServices);

    // Optional: keep only services that still exist in the updated list
    setSelectedServices((prevSelected) =>
      prevSelected.filter((service) =>
        uniqueServices.some((opt) => opt.value === service.value)
      )
    );
  };

  const handleServiceChange = (selected) => {
    setSelectedServices(selected);
  };

  const addmodalCancelData = () => {
    setState((state) => ({
      ...state,
      addBodyData: true,
    }));
  };
  const addBodyCloseData = () => {
    setState({
      ...state,
      addBodyData: false,
    });
  };
  const addBodyCancelData = () => {
    return (
      <>
        <DiscardChanges
          title={state.formData.id != 0 ? "edit" : "add"}
          discardClick={addmodalHide}
          cancelClick={addBodyCloseData}
        />
      </>
    );
  };
  const fetchListApi = () => {
    dispatch(Servicegroupdropdown()).then((data) => {
      let apiData = data.payload;
      setoptionfilter(apiData);
    });
  };
  const addBody = () => {
    return (
      <>
        {getDILoader || saveDILoader ? (
          <Spinners />
        ) : (
          <>
            {state.formData.id != 0 ? (
              <h4>Update Data Import Scheduler</h4>
            ) : (
              <h4>Add Data Import Scheduler</h4>
            )}
            <Row className="mt-3 m-0">
              <Col>
                <label>Module<span className="RedHighlight">*</span></label>
                <div className="frmgroup addSchedule">
                  <CustomSelectSearch
                    containerClassName="frmgroup default-input"
                    isSearchable={false}
                    placeholder="Select"
                    options={
                      Array.isArray(ModuleList)
                        ? ModuleList.map((Module, index) => ({
                          value: Module?.moduleName || `Module${index + 1}`,
                          label: Module?.moduleName || `Module ${index + 1}`,
                        }))
                        : []
                    }
                    isMulti={false}
                    value={
                      state.formData.modulename
                        ? {
                          value: state.formData.modulename,
                          label: state.formData.modulename,
                        }
                        : null
                    }
                    name={"Module"}
                    hideSelectedOptions={false}
                    closeMenuOnSelect={true}
                    isDisabled={state.formData.id !== 0}
                    onChange={(option) => {
                      onChange("modulename", option?.value);
                    }}
                  />
                </div>
              </Col>
              <Col>
                <ToolSelector
                  modulename={state.formData.modulename}
                  toolName={state.formData.toolName}
                  onChange={onChange}
                />
              </Col>
            </Row>
            {awsvalue && (
              <Row className="mt-3 m-0">
                <Col className="col-md-6">
                  <label>Groups<span className="RedHighlight">*</span></label>
                  <div className="frmgroup addSchedule">
                    <CustomSelectdata
                      containerClassName="frmgroup default-input"
                      placeholder="Group"
                      options={groupOptions}
                      multiSelect={true}
                      defaultSelected={selectedGroup}
                      name={"group"}
                      withSelectAll={true}
                      searchable={true}
                      isDisabled={state.formData.id !== 0}
                      onChange={handleGroupChange}
                    />
                  </div>
                </Col>
                <Col className="col-md-6">
                  <label>Services<span className="RedHighlight">*</span></label>
                  <div className="frmgroup addSchedule">
                    <CustomSelectdata
                      containerClassName="frmgroup default-input"
                      isSearchable={false}
                      placeholder="Service"
                      options={serviceOptions}
                      multiSelect={true}
                      defaultSelected={selectedServices}
                      name={"service"}
                      hideSelectedOptions={false}
                      closeMenuOnSelect={true}
                      withSelectAll={true}
                      searchable={true}
                      isDisabled={!selectedGroup || state.formData.id !== 0}
                      onChange={handleServiceChange}
                    />
                  </div>
                </Col>
              </Row>
            )}
            <Row className="mt-3 m-0">
              <Col className="col-md-4">
                <CustomSelectDropDown
                  containerClassName="frmgroup validate default-input"
                  labelName={"Import Frequency*"}
                  isSearchable={false}
                  placeholder="Select"
                  options={frequencyOptions}
                  value={frequencyOptions.find(
                    (data) => data.value === state.formData.importFrequency
                  )}
                  name={"Import Frequency"}
                  onChange={(choice) => {
                    onChange("importFrequency", choice.value);
                  }}
                />
              </Col>
              <Col className="col-md-4">
                {state.formData.importFrequency == "Weekly" ? (
                  <div className="frmgroup">
                    <label>Import On<span className="RedHighlight">*</span></label>
                    <CustomSelect
                      options={dayOption}
                      isMulti={true}
                      hideSelectedOptions={false}
                      isCheckboxSelect={true}
                      placeholder="Select"
                      searchPlaceHolder="Search"
                      isSearchable={false}
                      closeMenuOnSelect={false}
                      onChange={(selectedList) => {
                        handleSelected(selectedList);
                      }}
                      value={state.formData.importOn}
                    />
                  </div>
                ) : state.formData.importFrequency == "Monthly" ? (
                  <Multipledatepicker
                    onChange={handleDateChange}
                    label={"Import On*"}
                    format={"DD"}
                    value={state.formData.importOn}
                    id={"dataImpMultiDatePicker"}
                  />
                ) : (
                  <Input
                    type={"text"}
                    containerClassName={"frmgroup validate default-input"}
                    data-testid={"importOn"}
                    label={"Import On*"}
                    value={state.formData.importOn}
                    name={"importOn"}
                    onChange={(e) => onChange(e.target.name, e.target.value)}
                    autoComplete={"off"}
                    disabled={true}
                  />
                )}
              </Col>
              <Col className="col-md-4">
                <label>Import At<span className="RedHighlight">*</span></label>
                <TimePicker
                  onChange={handleTimeChange}
                  value={state.formData.scheduleTime}
                />
              </Col>
            </Row>
            <div className="server-btn mt-4 mx-1">
              <ButtonComponent
                text="Cancel"
                className={"cancelBtnStyle btn btn-primary"}
                data-testid="cancelBtn"
                onClick={() =>
                  state.conformationPopup
                    ? addmodalCancelData()
                    : addmodalHide()
                }
              />
              <ButtonComponent
                text="Save"
                className={"btnStyle btn btn-primary"}
                data-testid="saveBtn"
                onClick={() => saveFunction()}
              />
            </div>
          </>
        )}
      </>
    );
  };
  return (
    <>
      <DataImportTable
        data={props.data}
        handlePageLimitChange={props.handlePageLimitChange}
        handleSearch={props.handleSearch}
        handlePageChange={props.handlePageChange}
        handleAdd={handleAdd}
        getbyId={getbyId}
        changeStatus={changeStatus}
        headerSortingState={props?.headerSortingState}
        handleOnSorting={props.handleOnSorting}
      />
      <CustomModal
        modalOpen={state.addBodyOpen}
        modalBody={addBody}
        modalHide={addmodalHide}
        closeBtn={true}
        closeBtnFuc={addmodalHide}
      />
      <CustomModal
        modalOpen={state.addBodyData}
        modalBody={addBodyCancelData}
        modalHide={addmodalCancelData}
        closeBtn={true}
        closeBtnFuc={addBodyCloseData}
      />
    </>
  );
};
export default DataImportComponent;
DataImportComponent.propTypes = {
  initialState: PropTypes.object,
  customCallback: PropTypes.func,
  onSave: PropTypes.func,
  modulename: PropTypes.string.isRequired,
  toolName: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  data: PropTypes.string.isRequired,
  handlePageLimitChange: PropTypes.func.isRequired,
  handleSearch: PropTypes.func.isRequired,
  handlePageChange: PropTypes.func.isRequired,
};